module.exports = __webpack_public_path__ + "static/media/polygon.ea992c9a.svg";